/**
 * Réglages des modules : validation d'une modification, fusion, et valeurs
 * effectives (défauts du manifeste complétés par les valeurs enregistrées).
 */
/** Longueur maximale (en caractères) d'un réglage de type `texte`. */
export const LONGUEUR_MAX_TEXTE = 500;
function valeurValide(d, v) {
    switch (d.type) {
        case 'texte':
            return typeof v === 'string' && v.length <= LONGUEUR_MAX_TEXTE;
        case 'booleen':
            return typeof v === 'boolean';
        case 'nombre':
            return (typeof v === 'number' &&
                Number.isFinite(v) &&
                (d.min === undefined || v >= d.min) &&
                (d.max === undefined || v <= d.max));
        case 'choix':
            return typeof v === 'string' && Object.hasOwn(d.options, v);
    }
}
/** Motif de refus, ou `null`. `null` comme valeur demande le retour au défaut. */
export function validerReglages(defs, modif) {
    for (const [cle, v] of Object.entries(modif)) {
        // `hasOwn` : une clé comme `constructor` ne doit pas résoudre vers le prototype.
        const d = Object.hasOwn(defs, cle) ? defs[cle] : undefined;
        if (!d)
            return `réglage « ${cle} » inconnu`;
        if (v === null)
            continue;
        if (!valeurValide(d, v))
            return `réglage « ${cle} » : valeur refusée`;
    }
    return null;
}
/** Applique une modification déjà validée ; une clé à `null` est retirée. */
export function fusionnerReglages(actuels, modif) {
    const out = { ...actuels };
    for (const [cle, v] of Object.entries(modif)) {
        if (v === null)
            Reflect.deleteProperty(out, cle);
        else
            out[cle] = v;
    }
    return out;
}
/**
 * Valeurs effectives : une valeur enregistrée devenue invalide (manifeste
 * modifié depuis) retombe sur le défaut ; une clé orpheline est ignorée.
 */
export function valeursEffectives(defs, enregistres) {
    const out = {};
    for (const [cle, d] of Object.entries(defs)) {
        const v = Object.hasOwn(enregistres, cle) ? enregistres[cle] : undefined;
        out[cle] = v !== undefined && valeurValide(d, v) ? v : d.defaut;
    }
    return out;
}
//# sourceMappingURL=reglages.js.map